import { restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { AccountDto, ConfirmationCodeSentDto } from "./restModels";
import { SetPasswordRequestDto } from "./restRequests";

// ===== Аккаунт кабинета (REST /api/rest/warehouse/v1) =====
// Аккаунт бэк берёт из токена — идентификатор в запросах не передаём.

export const getAccount = () => restGet<AccountDto>("/account");

// Код подтверждения уходит SMS-кой на телефон аккаунта; ответ — сколько он ещё живёт.
export const sendConfirmationCode = () =>
    restPost<ConfirmationCodeSentDto>("/account/confirmation-code");

export const setAccountPassword = (body: SetPasswordRequestDto) =>
    restPut<AccountDto>("/account/password", body);
